$(document).ready(function () {
  $('.article-products').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<svg class="left-arrow" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" style=""><circle cx="21" cy="21" r="20.5" transform="matrix(-1 0 0 1 42 0)" stroke="black"></circle><path d="M22.2188 15.7188L17.7188 20.4688C17.5938 20.6354 17.5312 20.8125 17.5312 21C17.5312 21.1875 17.5938 21.3542 17.7188 21.5L22.2188 26.25C22.5521 26.5625 22.8958 26.5729 23.25 26.2812C23.5625 25.9479 23.5729 25.5938 23.2812 25.2188L19.2812 21L23.2812 16.75C23.5729 16.3958 23.5625 16.0521 23.25 15.7188C22.8958 15.4271 22.5521 15.4271 22.2188 15.7188Z" fill="#191C1F"></path></svg>',
        nextArrow: '<svg class="right-arrow" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" style=""><circle cx="21" cy="21" r="20.5" stroke="black"></circle><path d="M19.7812 15.7188L24.2812 20.4688C24.4062 20.6354 24.4688 20.8125 24.4688 21C24.4688 21.1875 24.4062 21.3542 24.2812 21.5L19.7812 26.25C19.4479 26.5625 19.1042 26.5729 18.75 26.2812C18.4375 25.9479 18.4271 25.5938 18.7188 25.2188L22.7188 21L18.7188 16.75C18.4271 16.3958 18.4375 16.0521 18.75 15.7188C19.1042 15.4271 19.4479 15.4271 19.7812 15.7188Z" fill="#191C1F"></path></svg>',
        cssEase: 'linear',
        responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 3
              }
            },
            {
                breakpoint: 1400,
                settings: {
                  slidesToShow: 3
                }
            },
            {
                breakpoint: 749,
                settings: {
                  slidesToShow: 2
                }
            }
        ]
    });
})